import { useCallback, forwardRef, ForwardRefRenderFunction, HTMLAttributes } from 'react';
import './TabTitle.css';

export interface iProps extends HTMLAttributes<HTMLButtonElement> {
  title: string;
  index: number;
  setSelectedTab: (props: iProps) => void;
  isActive?: boolean;
}

const TabTitle: ForwardRefRenderFunction<HTMLButtonElement, iProps> = (props, ref) => {

  const { title, setSelectedTab, isActive } = props;
  const onClickHandler = useCallback(() => {
    setSelectedTab(props);
  }, [setSelectedTab, props]);

  return (
    <button
      ref={ref} className={`tab-title ${!isActive ? 'inactive' : ''}`}
      onClick={onClickHandler}>{title}</button>
  )
}

export default forwardRef(TabTitle);